import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateExtensionMutationVariables = Types.Exact<{
  data: Types.CreateUserData;
}>;


export type CreateExtensionMutation = { __typename?: 'Mutation', createUser: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', context?: string | null, location: Array<string>, type: string }> | null } };

export type CreateExtensionUserMutationVariables = Types.Exact<{
  data: Types.CreateUserLoginInput;
}>;


export type CreateExtensionUserMutation = { __typename?: 'Mutation', addUserLogin?: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } | null };

export type CreateExtensionInfoQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  isSuperuser: Types.Scalars['Boolean']['input'];
}>;


export type CreateExtensionInfoQuery = { __typename?: 'Query', availableTranslations?: Array<string | null> | null, domainAllocation: { __typename?: 'DomainAllocations', capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', domainUsed: number, domainAllocated: number, totalAllocated?: number, systemLimit?: number | null, name: string }>, deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', domainUsed: number, domainAllocated: number, totalAllocated?: number, systemLimit?: number | null, name: string }>, userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', domainUsed: number, domainAllocated: number, name: string, totalAllocated?: number, systemLimit?: number | null, allocationIncrementError?: { __typename?: 'Error', type: string, context?: string | null } | null }> }, userPackages: Array<{ __typename?: 'UserPackageInfo', type: string, name: string, quota: number, capabilitySets: Array<string>, deviceTypeSets: Array<{ __typename?: 'UserPackageDeviceTypeSet', name: string, quantity: number }> }>, domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', domainType: Types.DomainType, defaultCapabilitySetForExtensions?: Array<string | null> | null, defaultDeviceLimits?: any | null, defaultUserPackage?: string | null } | null> } | null, locations?: { __typename?: 'LocationList', items: Array<{ __typename?: 'Location', id: number, name: string } | null> } | null, deviceTypeSets: Array<{ __typename?: 'DeviceTypeSet', name: string, devices: Array<string> }> };

export type CreateExtensionSuperuserQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type CreateExtensionSuperuserQuery = { __typename?: 'Query', domainAllocation: { __typename?: 'DomainAllocations', capabilitySets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, totalAllocated: number }>, deviceTypeSets: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, totalAllocated: number }> } };


export const CreateExtensionDocument = gql`
    mutation CreateExtension($data: CreateUserData!) {
  createUser(data: $data) {
    id
    errors {
      context
      location
      type
    }
  }
}
    `;
export type CreateExtensionMutationFn = Apollo.MutationFunction<CreateExtensionMutation, CreateExtensionMutationVariables>;

/**
 * __useCreateExtensionMutation__
 *
 * To run a mutation, you first call `useCreateExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtensionMutation, { data, loading, error }] = useCreateExtensionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateExtensionMutation(baseOptions?: Apollo.MutationHookOptions<CreateExtensionMutation, CreateExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExtensionMutation, CreateExtensionMutationVariables>(CreateExtensionDocument, options);
      }
export type CreateExtensionMutationHookResult = ReturnType<typeof useCreateExtensionMutation>;
export type CreateExtensionMutationResult = Apollo.MutationResult<CreateExtensionMutation>;
export type CreateExtensionMutationOptions = Apollo.BaseMutationOptions<CreateExtensionMutation, CreateExtensionMutationVariables>;
export const CreateExtensionUserDocument = gql`
    mutation CreateExtensionUser($data: CreateUserLoginInput!) {
  addUserLogin(loginData: $data) {
    errors {
      type
      context
      location
    }
  }
}
    `;
export type CreateExtensionUserMutationFn = Apollo.MutationFunction<CreateExtensionUserMutation, CreateExtensionUserMutationVariables>;

/**
 * __useCreateExtensionUserMutation__
 *
 * To run a mutation, you first call `useCreateExtensionUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExtensionUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExtensionUserMutation, { data, loading, error }] = useCreateExtensionUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateExtensionUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateExtensionUserMutation, CreateExtensionUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExtensionUserMutation, CreateExtensionUserMutationVariables>(CreateExtensionUserDocument, options);
      }
export type CreateExtensionUserMutationHookResult = ReturnType<typeof useCreateExtensionUserMutation>;
export type CreateExtensionUserMutationResult = Apollo.MutationResult<CreateExtensionUserMutation>;
export type CreateExtensionUserMutationOptions = Apollo.BaseMutationOptions<CreateExtensionUserMutation, CreateExtensionUserMutationVariables>;
export const CreateExtensionInfoDocument = gql`
    query CreateExtensionInfo($domainId: Int!, $isSuperuser: Boolean!) {
  domainAllocation(domainId: $domainId) {
    capabilitySets {
      domainUsed
      domainAllocated
      totalAllocated @include(if: $isSuperuser)
      systemLimit @include(if: $isSuperuser)
      name
    }
    deviceTypeSets {
      domainUsed
      domainAllocated
      totalAllocated @include(if: $isSuperuser)
      systemLimit @include(if: $isSuperuser)
      name
    }
    userPackages {
      domainUsed
      domainAllocated
      name
      totalAllocated @include(if: $isSuperuser)
      systemLimit @include(if: $isSuperuser)
      allocationIncrementError {
        type
        context
      }
    }
  }
  userPackages {
    type
    name
    quota
    capabilitySets
    deviceTypeSets {
      name
      quantity
    }
  }
  domains(id: $domainId) {
    items {
      domainType
      defaultCapabilitySetForExtensions
      defaultDeviceLimits
      defaultUserPackage
    }
  }
  locations(domainId: $domainId) {
    items {
      id
      name
    }
  }
  availableTranslations
  deviceTypeSets {
    name
    devices
  }
}
    `;

/**
 * __useCreateExtensionInfoQuery__
 *
 * To run a query within a React component, call `useCreateExtensionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateExtensionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateExtensionInfoQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      isSuperuser: // value for 'isSuperuser'
 *   },
 * });
 */
export function useCreateExtensionInfoQuery(baseOptions: Apollo.QueryHookOptions<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables> & ({ variables: CreateExtensionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>(CreateExtensionInfoDocument, options);
      }
export function useCreateExtensionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>(CreateExtensionInfoDocument, options);
        }
export function useCreateExtensionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>(CreateExtensionInfoDocument, options);
        }
export type CreateExtensionInfoQueryHookResult = ReturnType<typeof useCreateExtensionInfoQuery>;
export type CreateExtensionInfoLazyQueryHookResult = ReturnType<typeof useCreateExtensionInfoLazyQuery>;
export type CreateExtensionInfoSuspenseQueryHookResult = ReturnType<typeof useCreateExtensionInfoSuspenseQuery>;
export type CreateExtensionInfoQueryResult = Apollo.QueryResult<CreateExtensionInfoQuery, CreateExtensionInfoQueryVariables>;
export const CreateExtensionSuperuserDocument = gql`
    query CreateExtensionSuperuser($domainId: Int!) {
  domainAllocation(domainId: $domainId) {
    capabilitySets {
      name
      totalAllocated
    }
    deviceTypeSets {
      name
      totalAllocated
    }
  }
}
    `;

/**
 * __useCreateExtensionSuperuserQuery__
 *
 * To run a query within a React component, call `useCreateExtensionSuperuserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateExtensionSuperuserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateExtensionSuperuserQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useCreateExtensionSuperuserQuery(baseOptions: Apollo.QueryHookOptions<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables> & ({ variables: CreateExtensionSuperuserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>(CreateExtensionSuperuserDocument, options);
      }
export function useCreateExtensionSuperuserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>(CreateExtensionSuperuserDocument, options);
        }
export function useCreateExtensionSuperuserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>(CreateExtensionSuperuserDocument, options);
        }
export type CreateExtensionSuperuserQueryHookResult = ReturnType<typeof useCreateExtensionSuperuserQuery>;
export type CreateExtensionSuperuserLazyQueryHookResult = ReturnType<typeof useCreateExtensionSuperuserLazyQuery>;
export type CreateExtensionSuperuserSuspenseQueryHookResult = ReturnType<typeof useCreateExtensionSuperuserSuspenseQuery>;
export type CreateExtensionSuperuserQueryResult = Apollo.QueryResult<CreateExtensionSuperuserQuery, CreateExtensionSuperuserQueryVariables>;